/**
 * Polaris responses mirror the swagger contract of the scheduler API. Every array is
 * nullable server side, and the failure DTOs are returned with a 4xx/5xx status as well,
 * so read the collections defensively and expect `errorMessages` on the error branch too.
 */
export class CreatePolarisAccountsResponse {
  success: boolean;
  status: number;
  syncedUsers: PolarisUserToRemoteUser[];
  failurePolarisUserIds: number[];
  errorMessages: string[];
}

export class PolarisUserToRemoteUser {
  polarisUserId: number;
  remoteId: number;
}

export class SyncPolarisTailsResponse {
  success: boolean;
  status: number;
  createdAircraftProfileIds: number[];
  deactivatedAircraftProfileIds: number[];
  reactivatedAircraftProfileIds: number[];
  tailNumberChangeAircraftProfileIds: number[];
  failedCreateAircraftProfileIds: number[];
  failedDeactivateAircraftProfileIds: number[];
  failedReactivateAircraftProfileIds: number[];
  errorMessages: string[];
}

export class PolarisSyncTripResponse {
  success: boolean;
  status: number;
  tripCreated: boolean;
  previousTripDeleted: boolean;
  tripCreateConflictError: boolean;
  scheduledFlightIdsCreated: number[];
  scheduledFlightIdsUpdated: number[];
  scheduledFlightIdsDeleted: number[];
  scheduledFlightIdsFailedToCreate: number[];
  errorMessages: string[];
}

export class RiskAssessmentData {
  status: number;
  scheduledFlightId: number;
  stopCount: number;
  yieldCount: number;
  infoCount: number;
  remoteId: number;
  lastRunBy: string;
  lastRunAt: string;
  success: boolean;
  errorMessages: string[];
}

export class TripSyncStatusResponse {
  success: boolean;
  status: TripSyncStatus;
  flightIdsNotSynced: number[];
  flightIdsToWarn: number[];
  warnings: string[];
  riskAssessments: RiskAssessmentData[];
}

export enum TripSyncStatus {
  UNKNOWN, //Status unavailable
  NOT_SYNCED, //No successful syncing for trip & and legs attempted
  PARTIALLY_SYNCED, //Some legs were successfully syncd, others were not
  OUT_OF_SYNC_DATA, //One or more pieces of leg specific data has changed (airport code, dept/arr time, crew), requiring a new sync
  OUT_OF_SYNC_OTHER, //One or more legs have been deleted/added, or tail changed
  IN_SYNC //All leg data matches the last known sync values
}

export const DEFAULT_TRIP_SYNC_STATUS: TripSyncStatusResponse = {
  success: false,
  status: TripSyncStatus.NOT_SYNCED,
  flightIdsNotSynced: [],
  flightIdsToWarn: [],
  warnings: [],
  riskAssessments: []
};

export class RiskAssessmentUrlResponse {
  url: string;
}

export const URLTYPE_OPEN = 'open';
export const URLTYPE_EXECUTE = 'execute';
